module.exports = __webpack_public_path__ + "img/7.38c5cf18.png";